<ng-select [(ngModel)]="cityValue" (change)="rideTypeChanged()" placeholder="{{'application.ride_types' | translate}}"
  [closeOnSelect]="true" [searchable]="false" [selectOnTab]="true" appendTo="body"
  class="filters__dropdown dropdown--small dropdown--border">
  <ng-option *ngFor="let option of rideTypes" [value]="option.externalId">{{option.name | splitCamelCase}}</ng-option>
</ng-select>